"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _EmbeddedVideo = _interopRequireDefault(require("../../../shared/components/EmbeddedVideo/EmbeddedVideo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var EmbeddedVideoSection = function EmbeddedVideoSectionComponent(_ref) {
  var _ref$element$oembed = _ref.element.oembed,
      provider_name = _ref$element$oembed.provider_name,
      embed_url = _ref$element$oembed.embed_url,
      title = _ref$element$oembed.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__embedded-video"
  }, /*#__PURE__*/_react["default"].createElement(_EmbeddedVideo["default"], {
    providerName: provider_name,
    url: embed_url,
    title: title
  }));
};

EmbeddedVideoSection.propTypes = {
  element: _propTypes["default"].shape({
    oembed: _propTypes["default"].shape({
      embed_url: _propTypes["default"].string.isRequired
    }).isRequired
  }).isRequired
};
var _default = EmbeddedVideoSection;
exports["default"] = _default;